import type { AbsolutePath } from "shelving";

/** Replace the address and title shown in the browser. */
export function redirect(path: AbsolutePath, title = "Loading..."): void {
	window.history.replaceState(null, "", path);
	document.title = title;
}

/** Move the browser forward to a new URL and title. */
export function forward(path: AbsolutePath, title = "Loading..."): void {
	window.history.pushState(null, "", path);
	document.title = title;
}

/** Move the browser back to its previous URL. */
export function back(): void {
	// Triggers `popstate` on `window`
	window.history.back();
}
